<template>
	<div class="site-wrapper">
		<div class="site-content">

			<div class="page">
				<div class="page__header">
					<div class="page__container">
						<h1 class="page__title">
							{{ t('page.contact.title') }}
						</h1>
					</div>
				</div><!-- /.page__header -->
				<div class="page__content">

					<div class="page__container contact__container">
						<div class="row">
							<div class="col-md-6">
								<div class="contactFirstParag" v-html="t('contact.page.contacts.text')">

								</div>

							</div>
							<div class="col-md-6">
								<div class="leftContent">
									<div class="row">
										<div class="col-md-6"  v-html="t('contact.page.contacts.opening')">

										</div>
										<div class="col-md-6" v-html="t('contact.page.contacts.phones')">


										</div>
										<div class="col-md-6 clearBoth" v-html="t('contact.page.contacts.address')">


										</div>
										<div class="col-md-6" v-html="t('contact.page.contacts.service')">

										</div>

									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12 col-md-3 mt-4">

							</div>
							<div class="col-12 col-md-9">
								<div class="block mt-4">
									<div class="block__content">
										<!--<contact-form></contact-form>-->
									</div>
								</div>
							</div>
						</div>
					</div>
				</div><!-- /.page__content -->
			</div><!-- /.page -->

		</div>
		<aside-prefooter :prefooter="false"></aside-prefooter>
	</div>


</template>
<script>
	import AsidePrefooter from '@/components/layout/AsidePrefooter';
	//import ContactForm from '@/components/parts/ContactForm';


	export default {
		name: 'Contact',
		components: {
			AsidePrefooter,
			//ContactForm
		},
		mounted() {

		}
	}
</script>